export default "__VITE_ASSET__29bbbc20__"